define('modules/home/sidebar/views/search.result.view',[
    'jquery',
    'underscore',
    'backbone',
    "modules/home/dashboard/views/search.result.view",
    "text!modules/home/sidebar/templates/search.result.template.html"
], function(
    $,_,Backbone,
    SearchResultView,
    Template
){
    var SideBarSearchResultView = SearchResultView.extend({
        className: 'searchResult row animated fadeIn',
        template: _.template(Template),

        render:function(){
            var returnVal = SearchResultView.prototype.render.call(this); //override

            if(this.model.identityType != "person"){
                this.$('.searchResultIcon span').removeClass("relpro-person_silo");
                var logoUrl = window.utils.identity.getDomain(this.model['headline']);
                if (logoUrl) {
                    this.$('.searchResultIcon span').html('<img class="img-responsive companyLogoSmall" src="https://s3.amazonaws.com/relpro-company-logos/' + logoUrl + '.png">');
                } else {
                    this.$('.searchResultIcon span').addClass("relpro-building");
                }
            }
            this.$('img').on('error', $.proxy(this.replaceImage,this));

            return returnVal;
        },

        replaceImage:function(event){
            this.$(".searchResultIcon span").html('<span class="relpro relpro-building"></span>');
        }
    });
    return SideBarSearchResultView;
});

